import React from 'react';
import { Container, Header } from 'semantic-ui-react';
import { WarrantyClaimsForm } from '../forms';
import { PageHeader, Wrappers } from '../components';
import { authProptypes } from '../auth';
import { withPageViewTracking } from '../analytics';
import { withAuth } from '../auth';
import { withAnalytics } from '../analytics';
import { graphql } from 'react-apollo';
import { withNavigator } from '../routing';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Queries } from '../api';
import getObjectProperty from 'lodash/get';
import PropTypes from 'prop-types';

const WarrantyClaims = function(props) {
  return (
    <Wrappers.Layout menu>
      <Container as="main">
        <PageHeader overlap>
          <Header as="h1" data-qa="warranty-claims-header">
            <small>Warranty</small>
            <FormattedMessage
              id="title.warranty_claims"
              defaultMessage="Warranty Claims"
            />
          </Header>
        </PageHeader>

        {/*Need to wrap the WarrantyClaimsForm call with this because the graphQL query for pre-population is async. Otherwise we don't get the data ontime.*/}
        {props.authUser && props.brandsList && (
          <WarrantyClaimsForm {...props} />
        )}
      </Container>
    </Wrappers.Layout>
  );
};

WarrantyClaims.propTypes = {
  authUser: authProptypes.user,
  brandsList: PropTypes.array
};

export default withPageViewTracking()(
  injectIntl(
    withNavigator(
      withAuth(
        withAnalytics(
          graphql(Queries.getBrands, {
            props: props => {
              const brands = getObjectProperty(
                props,
                'data.getBrands',
                undefined
              );
              const brandsList =
                brands && brands.filter(brand => brand.farmBrand);
              return {
                ...props,
                brandsList
              };
            }
          })(WarrantyClaims)
        )
      )
    )
  )
);
